import React from "react";

const TitleInputSkeleton: React.FC = () => {
  return (
    <div className="w-full animate-pulse rounded-lg bg-white p-5 shadow lg:px-10 dark:bg-black">
      <div className="bg-cream-300 dark:bg-cream-700 h-6 w-2/3 rounded"></div>
    </div>
  );
};

export default TitleInputSkeleton;
